import React from 'react';
import { MapPin, Phone, Clock, Navigation } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { sucursales } from '../utils/mockData';

const Sucursales = () => {
  const openWhatsApp = (whatsapp) => {
    window.open(`https://wa.me/${whatsapp}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <section className="bg-gradient-to-r from-[#1e3a8a] to-[#1e40af] text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Nuestras Sucursales</h1>
          <p className="text-xl opacity-90">Encuentra la sucursal más cercana a ti</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 py-12">
        {/* Map */}
        <div className="mb-12">
          <Card className="shadow-xl">
            <CardContent className="p-0">
              <div className="h-96 md:h-[500px] w-full">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3761.4876!2d-99.2690990!3d19.4139435!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d201501ffa57c1%3A0x2bd6272eebe80393!2sCenzontle%20137%2C%20Palo%20Solo%2C%2052778%20Naucalpan%20de%20Ju%C3%A1rez%2C%20M%C3%A9x.!5e0!3m2!1ses!2smx!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="rounded-lg"
                />
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Sucursales List */}
        <div className="space-y-6">
          {sucursales.map((sucursal) => (
            <Card key={sucursal.id} className="shadow-lg hover:shadow-xl transition-shadow">
              <CardContent className="p-8">
                <div className="grid md:grid-cols-2 gap-8">
                  <div className="space-y-4">
                    <h2 className="text-2xl font-bold text-[#1e3a8a] mb-4">{sucursal.nombre}</h2>
                    
                    <div className="flex items-start gap-3">
                      <MapPin className="h-5 w-5 text-[#84cc16] mt-1 flex-shrink-0" />
                      <div>
                        <p className="font-semibold text-gray-700">Dirección</p>
                        <p className="text-gray-600">{sucursal.direccion}</p>
                      </div>
                    </div>

                    <div className="flex items-start gap-3">
                      <Phone className="h-5 w-5 text-[#84cc16] mt-1 flex-shrink-0" />
                      <div>
                        <p className="font-semibold text-gray-700">Teléfono</p>
                        <p className="text-gray-600">{sucursal.telefono}</p>
                      </div>
                    </div>

                    <div className="flex items-start gap-3">
                      <Clock className="h-5 w-5 text-[#84cc16] mt-1 flex-shrink-0" />
                      <div>
                        <p className="font-semibold text-gray-700">Horario</p>
                        <p className="text-gray-600">{sucursal.horario}</p>
                      </div>
                    </div>
                  </div>

                  <div className="space-y-4">
                    <div>
                      <h3 className="font-semibold text-gray-700 mb-2">Servicios disponibles</h3>
                      <ul className="space-y-2">
                        {sucursal.servicios.map((servicio, index) => (
                          <li key={index} className="flex items-center gap-2">
                            <div className="h-2 w-2 bg-[#84cc16] rounded-full" />
                            <span className="text-gray-600">{servicio}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="flex flex-col gap-3 pt-4">
                      <Button 
                        className="bg-[#84cc16] hover:bg-[#65a30d] text-white"
                        onClick={() => openWhatsApp(sucursal.whatsapp)}
                      >
                        <Phone className="mr-2 h-4 w-4" />
                        Contactar por WhatsApp
                      </Button>
                      <Button 
                        variant="outline" 
                        className="border-[#1e40af] text-[#1e40af] hover:bg-[#1e40af] hover:text-white"
                        onClick={() => window.open(`https://maps.google.com/?q=${sucursal.lat},${sucursal.lng}`, '_blank')}
                      >
                        <Navigation className="mr-2 h-4 w-4" />
                        Cómo llegar
                      </Button>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Info adicional */}
        <div className="mt-12 bg-blue-50 rounded-lg p-8 text-center">
          <h3 className="text-2xl font-bold text-[#1e3a8a] mb-4">
            ¿Necesitas servicio a domicilio?
          </h3>
          <p className="text-gray-600 mb-6">
            Ofrecemos servicio de recolección de muestras a domicilio. Contáctanos para más información.
          </p>
          <Button className="bg-[#1e40af] hover:bg-[#1e3a8a] text-white px-8 py-6 text-lg">
            Solicitar servicio a domicilio
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Sucursales;